import { handleDeleteRequest } from './pendingRequestHelpers'
import AppRoutes from '../routes/appRoutes'
import { trackDiscardEvent } from './sendGAAnalyticsEvent'

export const handleDiscard = (id, handleChangeOpen, history) => {
    if (!id) return
    handleChangeOpen(false)
    localStorage.setItem('successAction', 'discarded')
    localStorage.setItem('showSuccessMessage', 'true')
    window.dispatchEvent(new Event('storage'))
    handleDeleteRequest(id)
    history.push(`${AppRoutes.requests()}?activeTab=activeRequests`)
}

export const handleConfirmDiscard = (
    request,
    handleChangeAlert,
    handleChangeOpen,
    history,
    userId,
    isOffline,
) => {
    handleChangeAlert({
        title: 'Are you sure?',
        message: 'Discarding this request will remove it from your device.',
        type: 'error',
        textOk: 'Yes, discard',
        textCancel: 'No, cancel',
        onDone: () => {
            trackDiscardEvent(request, userId, isOffline)
            handleDiscard(request?.id, handleChangeOpen, history)
        },
        onCancel: () => handleChangeOpen(false),
    })
}
